import React from "react";
import Countdown from 'react-countdown'
import { Link } from 'react-router-dom';
import "./page.css"
import PanfuImg from "./パンフレット表紙絵.jpeg"
import PanfuPDF from "./東京学芸大学附属高校パンフレット.pdf"

export default function Main(){
    return(
        <div className="background">
        <section>
            <div className="concept-div">
                <div className="concept-left">
                    <img src={PanfuImg} className="concept-img" alt="パンフレット表紙絵"></img>
                </div>
                <div className="concept-right">
                    <h1 className="concept-kobushi">第69回　辛夷祭</h1>
                    <h2>今年のコンセプトは、”コブシ的転回”。<br/>あなたも一緒に、Let's コブ転！</h2>
                    <div className="panf-link"><a href={PanfuPDF} target="_blank">パンフレット(PDF)を表示</a></div>
                </div>
            </div>
        </section>
        
        <section>
            <div className="about-div container-div">
                <div className="about-left div-left">
                    <p>開始まであと</p>
                    <Countdown date={"2023-09-09T09:00:00"} className="countdown"/>
                </div>
                <div className="about-right div-right">
                    <h3>ABOUT</h3>
                    <p>名称：第69回　辛夷祭</p>
                    <p>場所：〒154-0002 東京都世田谷区下馬4-1-5</p>
                    <p>日時：2023年9月9日(土)・10日(日)</p>
                    <p>主催：東京学芸大学附属高等学校</p>
                </div>
            </div>
        </section>

        <section>
            <h2 className="section-title">NEWS</h2>
            <div className="news-div">
                2023/07/01　第69回辛夷祭　公式SNSはじめました！
                <br/>
                
                <br/>
                <Link to={`/69/pre/news`} className="news-link">本文を読む</Link>
            </div>
        </section>

        <section>
            <h2 className="section-title">ACCESS</h2>
            <div className="access-div container-div">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.730876982595!2d139.67614807588686!3d35.63436053254697!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f4b902592c33%3A0xe915c3353167217b!2z5p2x5Lqs5a2m6Iq45aSn5a2m6ZmE5bGe6auY562J5a2m5qCh!5e0!3m2!1sja!2sjp!4v1688194609620!5m2!1sja!2sjp" className="map" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            <div className="access-right">
                <h3>電車</h3>
                <p>・東急東横線<br/>「学芸大学」駅下車 徒歩15分</p>
                <p>・東急田園都市線<br/>「三軒茶屋」駅下車 徒歩20分</p>
                <h3>バス（東急バス）</h3>
                <p>【渋谷駅】<br/>31番のりば（渋32）「野沢龍雲寺循環」</p>
                <p>【目黒駅】<br/>2番のりば（黒06）「三軒茶屋駅」行き</p>
                <p>【三軒茶屋駅】<br/>6番のりば（黒06）「目黒駅前」行き</p>
                <p>いずれも「学芸大学附属高校」下車</p>
            </div>
            </div>
        </section>
        </div>
       
    )
}